import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const allVmsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.allAllowedActions',
        popover: {
          title: 'Available VM Actions',
          description:
            'This section lists all the actions you can perform on the virtual machines. These actions might include starting, stopping, or rebooting VMs, among others.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.vmMainTable',
        popover: {
          title: 'VM Management Table',
          description:
            'This table provides a comprehensive overview of all virtual machines. You can manage, monitor, and perform actions on your VMs from here.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default allVmsDriverObj;
